// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  //production: false, //comentar para pase
  production: true, //descomentar para pase

  //URL del servidor backend
  //URL_BACKEND: 'http://localhost:8085/fise-consultas',
  // URL_BACKEND: 'http://10.0.1.94/fise-consultas/fise-consultas',
  URL_BACKEND: '/fise-consultas',

  //Credenciales del usuario genérico para GNR
  GNR_GENERIC_USER: 'fise-consultas_GNR',
  GNR_GENERIC_PASSWORD: '$f153-c0n5ul74s_GNR$',
  GNR_GENERIC_KEY_SECRET: '3sE3sfr20Sx4x5GG',

  //Key para Google reCaptcha v3
  GOOGLE_RECAPTCHA_V3_SITE_KEY: '6LdwgpotAAAAAKTe3AUyYrgXrhW9u0O7q3wVTDhx',

  //Key para Google Maps
  GOOGLE_MAPS_API_KEY: 'AIzaSyDdhcxkb6eCKhS5-QvAn2bB01U-iHharVE',

  //Número de reintentos en las peticiones al servidor del backend
  REINTENTOS: 1

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
